module.exports = __webpack_public_path__ + "static/media/twitter.6a78298d.svg";